import { render, staticRenderFns } from "./webAi.vue?vue&type=template&id=66db02c7&scoped=true&"
import script from "./webAi.vue?vue&type=script&lang=js&"
export * from "./webAi.vue?vue&type=script&lang=js&"
import style0 from "./webAi.vue?vue&type=style&index=0&id=66db02c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db02c7",
  null
  
)

export default component.exports